import React, {useState, useEffect} from "react";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import SelectInput from "../form/input/SelectInput";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import {NotificationManager} from 'react-notifications';
import Paper from "@material-ui/core/Paper";
import TextInput from "../form/input/TextInput";
import AuthService from "../../services/auth.service";
import {Chip} from "@material-ui/core";
import Popup from "../presentation/Popup";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../presentation/ConfirmDialog";
import CheckBoxInput from "../form/input/CheckBoxInput";
import {useDashboardStyles} from "./dashboardStyles";

export default function ServiceDashboard(props) {
    const classes = useDashboardStyles();

    const [values, setValues] = useState({
        _id: null,
        name: '',
        type: 0,
        options: [],
        show_list: false,
        count_cost: false
    });

    const currentUser = AuthService.getCurrentUser();
    const [services, setServices] = useState([]);
    const [show, setShow] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''})
    const [optionTextCostInput, setOptionTextCostInput] = useState({
        text: '',
        cost: 0
    });
    const [optionTextInput, setOptionTextInput] = useState('');

    const handleTextCostOptionInputChange = (event) => {
        let {name, value} = event.target;
        setOptionTextCostInput({...optionTextCostInput, [name]: value});
    }

    const handleTextOptionInputChange = (event) => {
        let {value} = event.target;
        setOptionTextInput(value);
    }

    const addTextCostOption = () => {
        if (optionTextCostInput.text.length !== 0) {
            optionTextCostInput.cost = parseFloat(optionTextCostInput.cost);
            let newOpt = [...values.options];
            newOpt.push(optionTextCostInput);
            setValues({...values, options: newOpt});
        }
        setOptionTextCostInput({
            text: '',
            cost: 0
        });
    }

    const addTextOption = () => {
        if (optionTextInput.length !== 0) {
            let newOpt = [...values.options];
            newOpt.push(optionTextInput);
            setValues({...values, options: newOpt});
        }
        setOptionTextInput('');
    }

    const handleChange = (event) => {
        const {name, value} = event.target;
        setValues({...values, [name]: value});
    }

    useEffect(() => {
        UserService.getUser(currentUser.id).then(
            (response) => {
                setServices(response.data.service_templates);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
    }, [currentUser.id, props]);

    const resetToDefault = () => {
        setValues({
            _id: null,
            name: '',
            type: 0,
            options: [],
            show_list: false,
            count_cost: false
        });
        setOptionTextCostInput({
            text: '',
            cost: 0
        });
        setOptionTextInput('');
        setShow(false);
    }

    const errNotification = (e) => {
        if (e.response.status === 401) {
            logOut(props);
            NotificationManager.error('Musíte sa nanovo prihlásiť.', 'Chyba', 5000);
        } else {
            NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
        }
    }

    const handleCreate = (e) => {
        e.preventDefault();

        if (validate()) {
            let data = {
                _id: values._id,
                name: values.name,
                type: values.type,
                show_list: values.show_list,
                count_cost: values.count_cost
            };
            // eslint-disable-next-line default-case
            switch (values.type) {
                case 1:
                    data.text_option = values.options
                    break;
                case 4:
                    data.text_cost_option = values.options
                    break;
            }
            if (values._id) {
                UserService.updateServiceTemplate(data).then(
                    () => {
                        UserService.getUser(currentUser.id).then(
                            (response) => {
                                setServices(response.data.service_templates);
                                NotificationManager.success('Šablóna upravená!', 'Upravené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            } else {
                UserService.createServiceTemplate(data).then(
                    () => {
                        UserService.getUser(currentUser.id).then(
                            (response) => {
                                setServices(response.data.service_templates);
                                NotificationManager.success('Šablóna vytvorená!', 'Vytvorené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            }
        } else {
            NotificationManager.error('Skontrolujte vyplnený formulár!', 'Chyba', 5000);
        }
    };

    const [errors, setErrors] = useState({});

    const validate = () => {
        let temp = {};
        temp.name = values.name !== '' ? "" : "Vyplne názov."
        if (values.type === 1 && values.options.length === 0) {
            temp.type = 'Musíte mať aspon jendu možnosť!'
        }
        if (values.type === 4 && values.options.length === 0) {
            temp.type = 'Musíte mať aspon jendu možnosť!'
        }
        setErrors({...temp})
        // eslint-disable-next-line eqeqeq
        return Object.values(temp).every(x => x == "")
    }

    const handleDelete = (id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
        UserService.deleteServiceTemplate(id).then(
            () => {
                NotificationManager.success('Šablóna vymazaná!', 'Vymazané', 5000);
                UserService.getUser(currentUser.id).then(
                    (response) => {
                        setServices(response.data.service_templates);
                    },
                    (e) => {
                        if (e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        }
                    }
                );
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Šablónu sa nepodarilo odstrániť!', 'Chyba', 5000);
            }
        );
    }

    const handleEdit = (vals) => () => {
        if (vals.type === 4) {
            vals.options = vals.text_cost_option;
        }
        if (vals.type === 1) {
            vals.options = vals.text_option;
        }
        setValues(vals);
        setShow(true);
    }

    const handleRemove = (index) => {
        let newOpt = [...values.options];
        newOpt.splice(index, 1);
        setValues({...values, options: newOpt});
    }

    const showType = (type) => {
        switch (type) {
            case 0:
                return 'Textová hodnota';
            case 1:
                return 'Výber z textových možností';
            case 2:
                return 'Výber z áno/nie možností';
            case 3:
                return 'Číselná hodnota';
            default:
                return 'Výber z text + cena možností';
        }
    }

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <div>
                        <Title>Tvorba šablón pre služby</Title>
                    </div>
                    <div className={classes.sectionToolbar}>
                        <Button
                            startIcon={<AddIcon/>}
                            className={classes.primaryAction}
                            onClick={() => setShow(true)}
                        >
                            Vytvoriť službu
                        </Button>
                    </div>
                </div>

                {services.length === 0 ? (
                    <div className={classes.emptyState}>
                        Zatiaľ nemáte pridané žiadne šablóny pre služby.
                    </div>
                ) : (
                    <Grid container spacing={2}>
                        {services.map((item, index) => (
                            <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                                <div className={classes.templateCard}>
                                    <div className={classes.templateCardBody}>
                                        <span className={classes.templateTypeBadge}>{showType(item.type)}</span>
                                        <div className={classes.templateNameRow}>
                                            <h3 className={classes.templateName}>{item.name}</h3>
                                        </div>
                                        {item.type === 4 && (
                                            <div className={classes.templateChipBox}>
                                                {item.text_cost_option.map((opt, i) => (
                                                    <Chip
                                                        key={i}
                                                        className={classes.templateChip}
                                                        label={`${opt.text} — ${opt.cost} €`}
                                                        size="small"
                                                    />
                                                ))}
                                            </div>
                                        )}
                                        {item.type === 1 && (
                                            <div className={classes.templateChipBox}>
                                                {item.text_option.map((opt, i) => (
                                                    <Chip
                                                        key={i}
                                                        className={classes.templateChip}
                                                        label={opt}
                                                        size="small"
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.templateCardActions}>
                                        <ActionButton color="primary">
                                            <Tooltip title="Upraviť šablónu">
                                                <EditIcon onClick={handleEdit(item)} fontSize="small"/>
                                            </Tooltip>
                                        </ActionButton>
                                        <ActionButton color="secondary">
                                            <Tooltip title="Vymazať šablónu">
                                                <DeleteIcon
                                                    onClick={() => {
                                                        setConfirmDialog({
                                                            isOpen: true,
                                                            title: 'Naozaj chceš vymazať túto šablónu?',
                                                            subTitle: "Túto operáciu nevieš vrátiť.",
                                                            onConfirm: () => {
                                                                handleDelete(item._id)
                                                            }
                                                        })
                                                    }}
                                                    fontSize="small"
                                                />
                                            </Tooltip>
                                        </ActionButton>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                )}

                <Popup
                    title={values._id ? 'Úprava šablóny služby' : 'Pridanie šablóny služby'}
                    openPopup={show}
                    setOpenPopup={setShow}
                    additionalWork={resetToDefault}
                    actions={
                        <Button
                            variant="contained"
                            type="submit"
                            form="service-template-form"
                            className={classes.primaryAction}
                        >
                            {values._id ? "Upraviť šablónu" : "Pridať šablónu"}
                        </Button>
                    }
                >
                    <form id="service-template-form" autoComplete='off' onSubmit={handleCreate}>
                        <div className={classes.formField}>
                            <TextInput
                                label="Názov služby"
                                error={errors.name}
                                name={'name'}
                                value={values.name}
                                onChange={handleChange}
                                fullWidth
                            />
                        </div>
                        {!values._id && (
                            <div className={classes.formField}>
                                <SelectInput
                                    label="Typ služby"
                                    name={'type'}
                                    error={errors.type}
                                    value={values.type}
                                    options={[
                                        {value: 0, title: 'Textová hodnota'},
                                        {value: 1, title: 'Výber z textových možností'},
                                        {value: 2, title: 'Výber z áno/nie možností'},
                                        {value: 3, title: 'Číselná hodnota'},
                                        {value: 4, title: 'Výber z text + cena možností'},
                                    ]}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                        {values._id && (
                            <div style={{padding: '12px 16px', background: 'rgba(176, 141, 87, 0.10)', border: '1px solid rgba(176, 141, 87, 0.28)', borderRadius: 8, color: '#2c4767', fontSize: '0.88rem', marginBottom: 16, lineHeight: 1.5}}>
                                Zmeny v zobrazovaní dát v informačnom liste a orientačnej sumy sa
                                odzrkadlia až v novopridaných pohreboch.
                            </div>
                        )}
                        <div className={classes.formField}>
                            <CheckBoxInput
                                name={'show_list'}
                                label={'Zobrazovať v informačnom liste?'}
                                value={values.show_list}
                                onChange={handleChange}
                            />
                        </div>
                        {values.type > 2 && (
                            <div className={classes.formField}>
                                <CheckBoxInput
                                    name={'count_cost'}
                                    label={'Počítať hodnotu do orientačnej sumy?'}
                                    value={values.count_cost}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                        {values.type === 4 && (
                            <div className={classes.optionsCard}>
                                <div className={classes.optionsTitle}>Možnosti (text + cena)</div>
                                <div className={classes.optionsChips}>
                                    {values.options.length === 0 ? (
                                        <span style={{color: '#5a6675', fontSize: '0.85rem', fontStyle: 'italic'}}>Žiadne možnosti zatiaľ.</span>
                                    ) : values.options.map((opt, i) => (
                                        <Chip
                                            key={i}
                                            label={`${opt.text} — ${opt.cost} €`}
                                            onDelete={() => handleRemove(i)}
                                            deleteIcon={<DeleteIcon/>}
                                            className={classes.templateChip}
                                        />
                                    ))}
                                </div>
                                <div className={classes.optionsInputs}>
                                    <TextInput
                                        label="Názov možnosti"
                                        name={'text'}
                                        value={optionTextCostInput.text}
                                        onChange={handleTextCostOptionInputChange}
                                    />
                                    <TextInput
                                        label="Cena"
                                        name={'cost'}
                                        type="number"
                                        value={optionTextCostInput.cost}
                                        onChange={handleTextCostOptionInputChange}
                                    />
                                    <Button onClick={addTextCostOption} className={classes.secondaryAction}>Pridať</Button>
                                </div>
                            </div>
                        )}
                        {values.type === 1 && (
                            <div className={classes.optionsCard}>
                                <div className={classes.optionsTitle}>Možnosti (text)</div>
                                <div className={classes.optionsChips}>
                                    {values.options.length === 0 ? (
                                        <span style={{color: '#5a6675', fontSize: '0.85rem', fontStyle: 'italic'}}>Žiadne možnosti zatiaľ.</span>
                                    ) : values.options.map((opt, i) => (
                                        <Chip
                                            key={i}
                                            label={opt}
                                            onDelete={() => handleRemove(i)}
                                            deleteIcon={<DeleteIcon/>}
                                            className={classes.templateChip}
                                        />
                                    ))}
                                </div>
                                <div className={classes.optionsInputs}>
                                    <TextInput
                                        label="Názov možnosti"
                                        name={'name'}
                                        value={optionTextInput}
                                        onChange={handleTextOptionInputChange}
                                    />
                                    <Button onClick={addTextOption} className={classes.secondaryAction}>Pridať</Button>
                                </div>
                            </div>
                        )}
                    </form>
                </Popup>
            </Paper>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                icon={<DeleteIcon/>}
            />
        </Container>
    );
}
